// types.d.ts
import {
    INITIALIZE, SIGN_IN_SUCCESS, SIGN_UP_SUCCESS,LOGOUT_SUCCESS
} from "../actions";





const initialized = () => {
    return {
        initialized: false,
        isAuthenticated: false,
        user: null,
    }
};
const logout = () => {
    return {
        initialized: true,
        isAuthenticated: false,
        user: null,
    }
};

const reducer = (state = initialized(), action) => {

    const {data} = action;
    const DEFAULT = logout();
    switch (action?.type) {
        case INITIALIZE:
            return data
        case SIGN_IN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                user: data.user,
            }
        case SIGN_UP_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                user: data.user,
            }
        }

        case LOGOUT_SUCCESS:
            return DEFAULT
        default:
            return state;
    }
};

export default reducer;
